import React, { useState, useEffect, forwardRef } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Form, Tooltip } from "antd";

import { useDispatch } from "react-redux";
import SectionHeader from "../../components/global/SectionHeader";

import { Spin, notification,   Button } from "antd";
import { API_URL } from "../../environment";
import { PROJECT_ASSIGN } from "../../redux/Store/constants"; 
import { Link, useNavigate } from "react-router-dom"; 
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { useSidebar } from "../../components/provider/Provider"; 
import { updateStatus } from "../../api/user/userapi"; 
import Layout from "../../components/global/layout";
import ApiClient from "../../methods/api/apiClient";
import { BsArrowLeftSquare } from "react-icons/bs";
import moment from "moment"
const Logs = () => {
  const { setCourseId,   } = useSidebar();
  const [toggle, setToggle] = useState(false);
  const [array, setArray] = useState([]);
  const [loading, setLoading] = useState(false);
  let tl =localStorage.getItem("tl");
  let history = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  useEffect(() => {
    projectAssign();
  }, []); 

  const projectAssign = () => {
    setLoading(true);
    let data={
        projectId:id,
        memberId:''
    }
    ApiClient.allApi('allProjectMemberLogs',data).then((res)=>{
      if(res.success){
        setLoading(false);
        setArray(res.data); 
      //  setData(res.data)
      } else{
        setLoading(false);
      }
       })

  }; 


   
  const columns = [
   
    {
      title: "Member name",
      dataIndex: "name",
      field: "name",
      render: (text) => (
        <>
          {text && text.name ? (
            // <Link to={`/projectDetail?id=${text.id}`} className="text-link">
            //   <Tooltip title="View">
            // onClick={() => chapterIdHandle(text.id)}
                <span >
                  {text.fullName}
                </span>
            //   </Tooltip>
            // </Link>
          ) : (
            "--"
          )}
        </>
      ),
    }, 
 
    {
      title: "Department",
      dataIndex: "department",
      field: "department",
      render: (text, record) => (
        <>
               {text && text.department ? (
            
                <span >
                  {text.department}
                </span>      
          ) : (
            "--"
          )}
        </>
      ),
    },

    {
      title: "Project Status",
      dataIndex: "progress_status",
      field: "progress_status",
      render: (text, record) => (
        <>
          {
            <span
              className={`btn-w btn btn-warning text-${
                text.projectState == "rejected"
                  ? ""
                  : text.projectState == "inProgress"
                  ? ""
                  : ""
              } text-capitalize`}
            > 
              {text.projectState}
            </span>
          }
        </>
      ),
    }, 



    // ...(text.type==='added' ? [
    //   {
        
    //       title: "Project assign at",
    //       dataIndex: "Exit From Project",
    //       field: "Exit From Project",
    //       render: (text, record) => (
    //         <>
    //                      {text && text.createdAt ? (
       
    //                 <span >
    //                   {moment(text.createdAt).format('YYYY-MM-DD')}
    //                 </span>
       
    //           ) : (
    //             "--"
    //           )}
    //         </>
    //       ),
    //     }, 
    
    //   }
    // ] : []),

      {
        
          title: "Project assign at",
          dataIndex: "Exit From Project",
          field: "Exit From Project",
          render: (text, record) => (
            <>
                         {text && text.createdAt ? (
       
                    <span >
                      {moment(text.createdAt).format('YYYY-MM-DD')}
                    </span>
       
              ) : (
                "--"
              )}
            </>
          ),
        }, 
    
      



   

    {
      title: "Exit From Project",
      dataIndex: "Exit From Project",
      field: "Exit From Project",
      render: (text, record) => (
        <>
                     {text && text.endDate && text.type!='added'? (
       
                <span >
                   {moment(text.updatedAt).format('YYYY-MM-DD')}
                   </span>
             
          ) : (
            "--"
          )}
        </>
      ),
    }, 





  ];

  const data = localStorage.getItem('role') == 'bde' ?  columns.filter((item)=>item?.dataIndedx != "projecttask" )   : columns

 
  const newlyAddedChapter =
    array && array.length
      ? array.map((items) => {
          return {
            ...items,
          };
        })
      : [];
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  return (
    <Layout>
    <>
      <div>
      
        <div className="main-content">

        <div className="headings">
            <div className="d-flex align-items-center gap-3">
            <Tooltip title="Back Button">
                <p onClick={()=>history(-1)} className="pointer text-white  fs-3">
                  <BsArrowLeftSquare />
                </p>
              </Tooltip>
              <SectionHeader title="Logs" />
            </div>
          </div>


          <div className="section table table-striped">
         
            <Spin spinning={loading}>
              <MaterialTable
                options={{
                  showTitle: false,
                  pageSize: 10,
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  emptyRowsWhenPaging: false,
                }}
                columns={data}
                data={newlyAddedChapter}
                icons={tableIcons}
              />
            </Spin>
          </div>
        </div>
      </div>

      <Modal isOpen={toggle}>
        <ModalHeader>Reason for Progress Status</ModalHeader>
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={(e) => SubmitReason(e)}
          autoComplete="off"
        >
          <Form.Item
            // label="Reason"
            name="reason"
            rules={[{ required: true, message: "Please fill the input!" }]}
          >
            <ModalBody>
              <textarea
                className="form-control"
                id="message-text"
                placeholder="Enter Message"
                required
                style={{
                  width: "448px",
                }}
              />
            </ModalBody>
          </Form.Item>

          <ModalFooter>
            <Button color="orange" htmlType="submit">
              OK
            </Button>{" "}
            <Button color="secondary" onClick={() => setToggle(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
    </Layout>
  );
};

export default Logs;
